import { useContext } from "react";
import { useQuery } from "react-query";
import * as api from "../services";
import AppContext from "../appContext";

const initSettings = {
  boardId: null, // latest board view
  moodBoardId: -1, // latest board edit
  webRCache: [], // webR cache
};

export default function useSettings() {
  const {
    app: {
      client: { id: clientId },
      project: { id: projectId },
      sessionId,
    },
  } = useContext(AppContext);
  const {
    data: settings,
    isFetching: isSettingsLoading,
    refetch: refetchSettings,
  } = useQuery(
    ["settings", clientId, projectId, sessionId],
    () =>
      api
        .getSettings({ clientId, projectId, sessionId })
        .then((data) => data.data?.settings ?? initSettings),
    {
      placeholderData: () => initSettings,
      enabled: clientId !== -1,
    }
  );

  return { settings, isSettingsLoading, refetchSettings };
}
